import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import Table from "../../../../../../common/components/table";
import { useNavigate } from "react-router-dom";
import PageLoader from "../../../../../../components/PageLoader";
import { selectBlogRequestsListItems } from "../../../../../../redux/blog-requests/selector";
import { blogRequests } from "../../../../../../redux/blog-requests/action";
import { selectListItems } from "../../../../../../redux/library/selector";

const ManagementBlogRequests = () => {
	const dispatch = useAppDispatch()
  const libraryData = useSelector(selectListItems)
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
    const blogRequestItems = useSelector(selectBlogRequestsListItems)
    const [
        columnDefs,
        setColumnDefs
      ] = useState({});
      const createColumnDefs: any = () => {
        setColumnDefs([
          {
            field: 'Sl',
            sortable: false,
            filter: false,
            isSortLabel: true,
            headerName: 'Sl',
            cellRenderer (params: any) {
              return parseInt(
                params.node.id,
                10
              ) + 1;
            },
          },
          { field: 'AccountName', headerName: 'Account Name' },
          { field: 'Source', headerName: 'Source' },
          { field: 'Location', headerName: 'Location' },
          { field: 'SourceType', headerName: 'Source Type' },
          { field: 'Status', headerName: 'Status', cellRenderer: 'libraryRendererComponent', cellRendererParams: { library: libraryData?.result?.TaskStatus } },
          { field: 'OwnerAlias', headerName: 'Owner Alias' },
          { field: 'RelatedToType', headerName: 'Related To Type' },
          { field: 'Type', headerName: 'Type' },
          { field: 'Subject', headerName: 'Subject' },
          { field: 'StartDate', headerName: 'Start Date', isDateValueFormat:true },
          { field: 'EndDate', headerName: 'EndDate Date', isDateValueFormat:true }
      
        ]);
      }
    
  const fetchBlogRequest=()=>{
    dispatch(blogRequests.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/crm/tasks/list`,entity:'blogRequests',jsonData:{
  
    "PageNumber": pageData,
    "PageSize": 10,
    "SortField": "Id",
    "SortOrder": "desc",
    

    }}))
  }
  const handleEdit=(data: any)=>{
    navigate(`${data?.Id}`)
  }
  const handleAdd=()=>{
    navigate(`${0}`)
  }
  const additionButtons: any = [
    {
      name: 'Add BlogRequests',
      callback: () => handleAdd(),
    }
  ];
useEffect(() => {
    createColumnDefs()
    fetchBlogRequest()
}, [pageData])
const handleDelete=(data: any)=>{
dispatch(blogRequests.delete({
  url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/crm/tasks/delete`,
  entity: 'blogRequests',
  jsonData: {
    Records: [
      {
     
            Id: data?.Id
        }
      
    ]
  }
})).then(() => {
  dispatch(blogRequests.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/crm/tasks/list`,entity:'blogRequests',jsonData:{
  
    "PageNumber": pageData,
    "PageSize": 10,
    "SortField": "Id",
    "SortOrder": "desc",
    

    }}))
});
}
return (
<>
{blogRequestItems?.isLoading ?  <PageLoader />: 
<Table columnData={columnDefs} rowData={blogRequestItems?.result?.items} setPageData={setPageData}
paginationData={blogRequestItems?.result?.pagination} onEdit={handleEdit} additionButtons={additionButtons} onDelete={handleDelete}headingName="Blog Requests"/>
 
}
</> 
);
};

export default ManagementBlogRequests;


